import { render, staticRenderFns } from "./ProfilePassport.vue?vue&type=template&id=061ba012&scoped=true"
import script from "./ProfilePassport.js?vue&type=script&lang=js&external"
export * from "./ProfilePassport.js?vue&type=script&lang=js&external"
import style0 from "./ProfilePassport.scss?vue&type=style&index=0&id=061ba012&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ba012",
  null
  
)

export default component.exports